import {ISoftPullData} from 'Src/components/pages/SoftPull/PageContextTypes'

export const getDataForSoftPullEndpoint = ({data}): ISoftPullData => {
  return {
    type: 'setSoftPullData',
    payload: {
      customerId: data.id,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone,
      address: data.address,
      city: data.cityCounty.city,
      zipCode: data.zipCode,
      state: data.state,
      consentAuthorized: data.legalCheckbox,
    },
  }
}
